import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "kind", "year", "row", "group"]

  connect() {
    this.kind = "all"
    this.filter()
  }

  pick(event) {
    this.kind = event.params.kind
    this.kindTargets.forEach((button) => {
      const active = button === event.currentTarget
      button.classList.toggle("ledger-segment__button--active", active)
      button.setAttribute("aria-pressed", active)
    })
    this.filter()
  }

  filter() {
    const query = this.hasQueryTarget ? this.queryTarget.value.trim().toLowerCase() : ""
    const year = this.hasYearTarget ? this.yearTarget.value : ""

    this.rowTargets.forEach((row) => {
      const visible =
        (this.kind === "all" || row.dataset.kind === this.kind) &&
        (year === "" || row.dataset.year === year) &&
        (query === "" || row.dataset.search.includes(query))
      row.hidden = !visible
    })

    this.groupTargets.forEach((group) => {
      const rows = group.querySelectorAll("tr[data-kind]")
      group.hidden = rows.length > 0 && Array.from(rows).every((row) => row.hidden)
    })
  }
}
